export function getColumnObjectValueFromString<T extends object>(
  value: string,
  optionByStringMap: Map<string, T>,
): T | null {
  if (value.startsWith('{') && value.endsWith('}')) {
    return JSON.parse(value) as T;
  }
  return optionByStringMap.get(value) ?? null;
}
